import apiClient from 'api/client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const PROCUREMENT_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TRACEABILITY,
  VERSIONS.V1,
  RESOURCES.PROCUREMENT,
  false
);

export const procurementApi = {
  procurementForm: () => apiClient.get(`${PROCUREMENT_BASE}/form`),

  editProcurementForm: Id =>
    apiClient.get(`${PROCUREMENT_BASE}/form?is_edit=true&procurement_id=${Id}`),

  createProcurement: combinedData =>
    apiClient.post(`${PROCUREMENT_BASE}`, combinedData),

  updateProcurement: (procurement_id, combinedData) =>
    apiClient.put(`${PROCUREMENT_BASE}/${procurement_id}`, combinedData)
};
